import { getObjectPath, setObjectPath } from "@redotech/util/object";
import { log } from "./log";

interface ReportTimingOptions {
  value?: number;
  overwrite?: boolean;
}

export function reportTiming(
  path: string,
  options: ReportTimingOptions = {},
): void {
  try {
    const { value = performance.now(), overwrite = false } = options;

    if (!window.redoStorefront) {
      window.redoStorefront = { type: "shopify" as const, timing: {} };
    }

    if (!window.redoStorefront.timing) {
      window.redoStorefront.timing = {};
    }

    if (
      overwrite ||
      getObjectPath(window.redoStorefront.timing, path) == null
    ) {
      setObjectPath(window.redoStorefront.timing, path, value);
    }
  } catch (error) {
    // Silently fail to avoid breaking the application
    log("Failed to report timing:", error);
  }
}

// Initialize timing tracking with empty objects
export function initializeTiming(): void {
  try {
    if (!window.redoStorefront) {
      window.redoStorefront = { type: "shopify" as const, timing: {} };
    }

    if (!window.redoStorefront.timing) {
      window.redoStorefront.timing = {};
    }

    if (!window.redoStorefront.timing.tryFirst) {
      window.redoStorefront.timing.tryFirst = {
        pageLoad: 0,
        initializeFunctionCalled: undefined,
        autocheckCacheRetrieved: undefined,
        contextProviderAdded: undefined,
        sellingPlansRetrieved: undefined,
        eligibilityChecked: undefined,
        buttonIsEligibleToShow: undefined,
        buttonRendered: undefined,
      };
    }
  } catch (error) {
    console.warn("Failed to initialize timing:", error);
  }
}
